import React, { FC, useCallback } from 'react'
import { Button } from '@wmgtech/legato'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { IsaacTable, IDeleteArguments } from 'components/Project/IsaacTable'
import {
  onNotifySuccessIssacRemove,
  onNotifySuccessIssacUpdate,
  onNotifySuccessIssacAppend
} from 'modulesCommon/Forms/utils/issakUtils'
import { IProjectForm } from 'modules/ProjectEdit/types'
import './IssacLinks.scss'

const IsaacLinks: FC<{ isLocalizing?: boolean; isGlobal?: boolean }> = ({ isLocalizing = false, isGlobal = false }) => {
  const { setValue, reset, getValues } = useFormContext<IProjectForm>()
  const { fields, append, remove } = useFieldArray<IProjectForm, 'isaacUrl', 'isaacUrl'>({
    name: 'isaacUrl'
  })

  const onIsaacLinkAdd = useCallback(() => {
    reset()
    append({ title: '', url: '' })
    setValue('editRow', getValues('isaacUrl').length - 1)
  }, [append, reset, setValue, getValues])

  const handleRowDelete = useCallback(
    ({ idx, message }: IDeleteArguments) => {
      onNotifySuccessIssacRemove(message)
      remove(idx)
      reset(getValues())
    },
    [remove, reset, getValues]
  )

  const handleSubmitLine = useCallback(
    (type: 'append' | 'update', text: string) => {
      if (type === 'append') {
        onNotifySuccessIssacAppend(text)
      } else {
        onNotifySuccessIssacUpdate(text)
      }
      reset(getValues())
    },
    [getValues, reset]
  )

  return (
    <section className="isaac-links-table">
      <h1>{`${isGlobal ? 'Global ' : !isLocalizing ? 'Local ' : ''}ISAAC Links`}</h1>
      <IsaacTable
        hidden={!fields.length}
        data={fields}
        onDelete={handleRowDelete}
        className="isaac-links-table__table"
        prefix="isaacUrl"
        isLocalizing={isLocalizing}
        isGlobal={isGlobal}
        onSubmitChange={handleSubmitLine}
      />
      <Button
        size="sm"
        secondaryIcon="plus-circle"
        containerStyle="outline"
        colorType="secondary-black"
        className="isaac-links-table__new-link-button"
        label={isLocalizing ? 'Add new local ISAAC link' : 'Add new ISAAC link'}
        onClick={onIsaacLinkAdd}
      />
    </section>
  )
}

export default IsaacLinks
